import { AsyncPipe, NgTemplateOutlet } from '@angular/common';
import { ChangeDetectionStrategy, Component, contentChild, input, output, viewChild } from '@angular/core';
import { FaIconComponent } from '@fortawesome/angular-fontawesome';
import { BehaviorSubject } from 'rxjs';

import { LazyLoadingContentDirective } from 'ish-core/directives/lazy-loading-content.directive';
import { ModalDialogComponent, ModalOptions } from 'ish-shared/components/common/modal-dialog/modal-dialog.component';

@Component({
  selector: 'custom-mini-cart-remove-item-confirmation-modal',
  templateUrl: './custom-mini-cart-remove-item-confirmation-modal.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [FaIconComponent, ModalDialogComponent, NgTemplateOutlet, AsyncPipe],
})
export class CustomMiniCartRemoveItemConfirmationModalComponent {
  /**
   * Modal dialog options (see also @ModalDialogComponent).
   */
  readonly options = input<ModalOptions>(undefined);

  readonly confirm = output<boolean>();

  readonly modal = viewChild<ModalDialogComponent<unknown>>('modalDialog');

  readonly lazyContent = contentChild(LazyLoadingContentDirective);

  shown$ = new BehaviorSubject(false);

  /** enable parent components to close the modal */
  hide() {
    this.modal().hide();
  }

  shown(): void {
    this.shown$.next(true);
  }

  closed(): void {
    this.shown$.next(false);
  }

  confirmed(): void {
    this.confirm.emit(true);
  }
}
